import Slider, { SliderProps } from '@mui/material/Slider';
import { FunctionComponent } from 'react';
import { getTheme } from '../../theme/getTheme';

export const SliderInput: FunctionComponent<SliderProps> = (props) => {
  const theme = getTheme();

  return (
    <Slider
      {...props}
      sx={{
        color: theme.colors.teal,
        '&': {
          height: 6,
        },
        '& .MuiSlider-mark': {
          display: 'none',
        },
        '& .MuiSlider-thumb': {
          '&:hover, &.Mui-focusVisible': {
            boxShadow: `0px 0px 0px 8px rgb(81 192 172 / 16%)`,
          },
        },
        '& .MuiSlider-markLabel': {
          top: 40,
          fontSize: 15,
          color: 'white',
          fontFamily: 'inherit !important',
        },
      }}
    />
  );
};
